import { render } from "./GroupCreate.vue?vue&type=template&id=2ed059a7&scoped=true"
import script from "./GroupCreate.vue?vue&type=script&lang=js"
export * from "./GroupCreate.vue?vue&type=script&lang=js"

import "./GroupCreate.vue?vue&type=style&index=0&id=2ed059a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed059a7"]])

export default __exports__